import { render, staticRenderFns } from "./Pagetitle.vue?vue&type=template&id=dbb6043c&"
import script from "./Pagetitle.vue?vue&type=script&lang=js&"
export * from "./Pagetitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports